import type { ContentStepType, IContentStep } from '@/shared/types/lesson';

export type LessonStepTheme = 'blue' | 'red' | 'green';

export const LESSON_STEP_THEME_COLORS: Record<
  LessonStepTheme,
  { primary: string; label: string }
> = {
  blue: { primary: '#211D55', label: 'Royal Blue' },
  red: { primary: '#630000', label: 'Academic Red' },
  green: { primary: '#182A24', label: 'Deep Forest Green' },
};

const LESSON_STEP_TYPE_THEME: Record<ContentStepType, LessonStepTheme> = {
  general: 'blue',
  scorm: 'red',
  video: 'green',
};

export const getLessonStepTheme = (type: ContentStepType): LessonStepTheme =>
  LESSON_STEP_TYPE_THEME[type];

export const getLessonStepTitle = (step: IContentStep): string => {
  if (step.title) return step.title;
  if (step.type === 'video') return 'Video';
  if (step.type === 'scorm' && step.scorm?.title) return step.scorm.title;
  return `Step ${step.order}`;
};
